/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState } from 'react';
import {
  FiPackage, FiMinusCircle, FiList, FiDivideSquare, FiBox,
} from 'react-icons/fi';
import { toast } from 'react-toastify';

function Issue() {
  const [form, setForm] = useState({
    product: '',
    category: '',
    quantity: '',
    unit: '',
    issuedTo: '',
    purpose: '',
  });

  const categories = ['Meat', 'Oil', 'Vegetables', 'Spices', 'Fruits', 'Dairy', 'Bakery', 'Beverages', 'Water'];
  const units = ['Piece', 'Kg', 'Liter', 'Box', 'Packet'];
  const staffMembers = ['Kitchen Staff', 'Service Staff', 'Bar', 'Bakery', 'Management'];
  const purposes = ['Daily Usage', 'Special Event', 'Waste', 'Staff Meal', 'Other'];

  const products = [
    { name: 'সরিষা তেল', category: 'Oil', unit: 'Liter' },
    { name: 'Mutton', category: 'Meat', unit: 'Kg' },
    { name: 'Tomato', category: 'Vegetables', unit: 'Kg' },
    { name: 'জিরা', category: 'Spices', unit: 'Kg' },
    { name: 'Apple', category: 'Fruits', unit: 'Piece' },
  ];

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!form.product || !form.category || !form.quantity || !form.unit || !form.issuedTo) {
      toast.error('Please fill in all required fields');
      return;
    }

    toast.success(
      <div>
        <p className="font-semibold">Stock Issued Successfully</p>
        <p>
          {form.quantity}
          {' '}
          {form.unit}
          {' '}
          of
          {' '}
          {form.product}
        </p>
        <p>
          Issued to:
          {form.issuedTo}
        </p>
      </div>,
      { autoClose: 3000 },
    );

    setForm({
      product: '',
      category: '',
      quantity: '',
      unit: '',
      issuedTo: '',
      purpose: '',
    });
  };

  const handleProductSelect = (productName) => {
    const selectedProduct = products.find((p) => p.name === productName);
    if (selectedProduct) {
      setForm({
        ...form,
        product: selectedProduct.name,
        category: selectedProduct.category,
        unit: selectedProduct.unit,
      });
    }
  };

  return (
    <div className="max-w-2xl mx-auto p-6 bg-gray-50 rounded-lg shadow-sm">
      <div className="flex items-center mb-6">
        <FiMinusCircle className="text-red-600 text-2xl mr-2" />
        <h1 className="text-2xl font-bold text-gray-800">Issue Stock</h1>
      </div>

      <form onSubmit={handleSubmit} className="space-y-5">
        <div className="bg-white p-5 rounded-lg border shadow-sm">
          <h2 className="text-lg font-semibold mb-4 flex items-center text-slate-900">
            <FiPackage className="mr-2 text-red-500" />
            Product Information
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="md:col-span-2">
              <label htmlFor="product" className="block text-sm font-medium text-gray-700 mb-1">
                Product Name *
              </label>
              <input
                id="product"
                type="text"
                list="product-list"
                placeholder="Enter product name"
                value={form.product}
                onChange={(e) => {
                  setForm({ ...form, product: e.target.value });
                  handleProductSelect(e.target.value);
                }}
                className="w-full border border-gray-300 p-2 rounded-md focus:ring-2 focus:ring-red-500 focus:border-red-500"
              />
              <datalist id="product-list">
                {products.map((product) => (
                  <option key={product.name} value={product.name}>
                    {product.name}
                    {' '}
                    (
                    {product.category}
                    )
                  </option>
                ))}
              </datalist>
            </div>

            <div>
              <label htmlFor="category" className="block text-sm font-medium text-gray-700 mb-1">
                Category *
              </label>
              <div className="relative">
                <select
                  id="category"
                  value={form.category}
                  onChange={(e) => setForm({ ...form, category: e.target.value })}
                  className="w-full border border-gray-300 p-2 rounded-md focus:ring-2 focus:ring-red-500 focus:border-red-500 appearance-none"
                >
                  <option value="">Select Category</option>
                  {categories.map((cat) => (
                    <option key={cat} value={cat}>{cat}</option>
                  ))}
                </select>
                <FiList className="absolute right-3 top-3 text-gray-400 pointer-events-none" />
              </div>
            </div>

            <div>
              <label htmlFor="unit" className="block text-sm font-medium text-gray-700 mb-1">
                Unit *
              </label>
              <div className="relative">
                <select
                  id="unit"
                  value={form.unit}
                  onChange={(e) => setForm({ ...form, unit: e.target.value })}
                  className="w-full border border-gray-300 p-2 rounded-md focus:ring-2 focus:ring-red-500 focus:border-red-500 appearance-none"
                >
                  <option value="">Select Unit</option>
                  {units.map((unit) => (
                    <option key={unit} value={unit}>{unit}</option>
                  ))}
                </select>
                <FiDivideSquare className="absolute right-3 top-3 text-gray-400 pointer-events-none" />
              </div>
            </div>

            <div>
              <label htmlFor="quantity" className="block text-sm font-medium text-gray-700 mb-1">
                Quantity *
              </label>
              <input
                id="quantity"
                type="number"
                step="0.01"
                min="0"
                placeholder="Enter quantity"
                value={form.quantity}
                onChange={(e) => setForm({ ...form, quantity: e.target.value })}
                className="w-full border border-gray-300 p-2 rounded-md focus:ring-2 focus:ring-red-500 focus:border-red-500"
              />
            </div>
          </div>
        </div>

        <div className="bg-white p-5 rounded-lg border shadow-sm">
          <h2 className="text-lg font-semibold mb-4 flex items-center text-slate-900">
            <FiBox className="mr-2 text-red-500" />
            Issuance Details
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label htmlFor="issuedTo" className="block text-sm font-medium text-gray-700 mb-1">
                Issued To *
              </label>
              <div className="relative">
                <select
                  id="issuedTo"
                  value={form.issuedTo}
                  onChange={(e) => setForm({ ...form, issuedTo: e.target.value })}
                  className="w-full border border-gray-300 p-2 rounded-md focus:ring-2 focus:ring-red-500 focus:border-red-500 appearance-none"
                >
                  <option value="">Select Department/Staff</option>
                  {staffMembers.map((staff) => (
                    <option key={staff} value={staff}>{staff}</option>
                  ))}
                </select>
              </div>
            </div>

            <div>
              <label htmlFor="purpose" className="block text-sm font-medium text-gray-700 mb-1">
                Purpose
              </label>
              <div className="relative">
                <select
                  id="purpose"
                  value={form.purpose}
                  onChange={(e) => setForm({ ...form, purpose: e.target.value })}
                  className="w-full border border-gray-300 p-2 rounded-md focus:ring-2 focus:ring-red-500 focus:border-red-500 appearance-none"
                >
                  <option value="">Select Purpose</option>
                  {purposes.map((purpose) => (
                    <option key={purpose} value={purpose}>{purpose}</option>
                  ))}
                </select>
              </div>
            </div>
          </div>
        </div>

        <div className="flex justify-end">
          <button
            type="submit"
            className="px-6 py-3 bg-red-600 text-white rounded-md shadow hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 font-medium flex items-center"
          >
            <FiMinusCircle className="mr-2" />
            Issue Stock
          </button>
        </div>
      </form>
    </div>
  );
}

export default Issue;
